const size = {
  laptopS: '900px',
  laptopM: '1366px',
  laptopL: '1920px',
};
export default size;
